// extracted by mini-css-extract-plugin
module.exports = {"dark":"Themes_dark__O1_AN","light":"Themes_light__zBdDR"};